import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

export const useDisableNotifications = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (deviceToken) => {
      const formData = new FormData();
      formData.append('device_token', deviceToken || '');
      const response = await apiClient.post('/disable-notifications', formData);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
};